function wholesaleAddtocart(productRow) {
  const variantId = document.querySelector('#' + productRow + ' .wholesale-variant-id').value;
  const quantity = document.querySelector('#' + productRow + ' .quantity-input').value;
  const price = document.querySelector('#' + productRow + ' .wholesale-variant-id').getAttribute('data-price');
  const productImage = document.querySelector('#' + productRow + ' .product-image a img').src;
  const productTitle = document.querySelector('#' + productRow + ' .product-name a h2').textContent;
  const spinner = document.querySelector('#' + productRow + ' .mp-loading__spinner');
  const buttonName = document.querySelector('#' + productRow + ' .button-name');

  
  console.log(productImage)
  spinner.style.display = 'block';
  buttonName.style.display = "none"
  
  let item = {
        items: [
        {
         id: variantId,
         quantity: quantity
        }
    ]
  }


function cartCount() {
  const headerCart = document.querySelector('.site-header-cart--count')
  const currentCartQnty = headerCart.getAttribute('data-header-cart-count')

  if(currentCartQnty == ''){
      headerCart.setAttribute('data-header-cart-count', quantity )
      headerCart.classList.add('visible')
  }else{
     let totalCart = parseInt(currentCartQnty) + parseInt(quantity);
      headerCart.setAttribute('data-header-cart-count', totalCart )
  }
  
}
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(item)
  })
  .then(response => {
      if (!response.ok) {
      throw new Error("Network response was not ok");
      }
      return response.json();
  })
  .then(data => {
    
    spinner.style.display = 'none';
    buttonName.style.display = "block";
    cartCount();
    console.log(data)
    // newMiniCartDrawer(data);


  })
  .catch((error) => {
    console.error('Error:', error);
  });



      function newMiniCartDrawer(cartDetails){
        const cartDrawer = document.querySelector('.b2b-mini-cart');
        const cdImgDiv = document.querySelector('.b2b-mini-cart .product-image');
        const cdTitleDiv = document.querySelector('.b2b-mini-cart .product-name');
        const cdSubTotalDiv = document.querySelector('.b2b-mini-cart .item-subtotal');
        const cartTotalItemDiv = document.querySelector('.b2b-mini-cart .cartTotalItem');
        const cartsubTotalmDiv = document.querySelector('.b2b-mini-cart .b2b-mini-cart-subtotal .subtotal-amount');

        const subTotal = `<span class="isolate notranslate body2 text_bold">${price}</span><span class="notranslate body2 text_bold trade-cart-sku-item-info-amount-sign">x&nbsp<span class="notranslate body2 text_bold trade-cart-sku-item-info-amount-count">${quantity}</span></span>`;
        const imgWithLink = `<img src="${productImage}" alt="">`
        cartDrawer.classList.add('top-drawer--open');
        cartDrawer.style.display = 'block';

        function addData(){
            cdImgDiv.innerHTML = imgWithLink;
            cdTitleDiv.innerHTML = productTitle;
            cdSubTotalDiv.innerHTML = subTotal;
            cartTotalItemDiv.innerHTML = cartDetails.item_count;
            if(cartDetails.currency == 'USD'){
                cartsubTotalmDiv.innerHTML = '$' + cartDetails.items_subtotal_price;
            }else{
                cartsubTotalmDiv.innerHTML = cartDetails.currency + cartDetails.items_subtotal_price;
            }
        }
        addData()
    }



    


}
    // B2B Mini Cart Drawer hide
    // const cartDrawer = document.querySelector('.b2b-mini-cart');
    // const cartCloseButton = document.querySelector('.b2b-mini-cart .cart-banner--close');
    
    // cartCloseButton.addEventListener('click', function() {
    //     cartDrawer.style.display = 'none';
    // });


// B2B Product Table Quantity Selector
document.addEventListener('DOMContentLoaded', function () {
    const quantityInputs = document.querySelectorAll('.quantity-input');

    quantityInputs.forEach(function (input) {
        const decrementButton = input.parentElement.querySelector('.qnty-minus');
        const incrementButton = input.parentElement.querySelector('.qnty-plus');

        decrementButton.addEventListener('click', function () {
            decrementQuantity(input);
        });

        incrementButton.addEventListener('click', function () {
            incrementQuantity(input);
        });
    });
});

function incrementQuantity(input) {
    let currentValue = parseInt(input.value, 10);
    input.value = currentValue + 1;
}

function decrementQuantity(input) {
    let currentValue = parseInt(input.value, 10);
    if (currentValue > 1) {
        input.value = currentValue - 1;
    }
}



// On Page Popup

